<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-datablock-action-popup">
		<div class="app-datablock-action-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span i18n="@@datablock.action.popup.concernedElement">
					concerned Element
				</span>
				<span class="app-datablock-action-popup__element-label">
					{{ vo.element }}
				</span>
			</ng-container>
			<ng-container *ngIf="vo.isMultipleElement">
				<span i18n="@@datablock.action.popup.concernedElements">
					concerned Elements
				</span>
				<div class="app-datablock-action-popup__element-label">
					{{ vo.datablockId.length }}
					<span i18n="@@datablock.action.popup.datablocks">datablocks</span>
				</div>
			</ng-container>
		</div>
		<ng-container [ngSwitch]="vo.action">
			<div
				*ngSwitchCase="DatablockAction.Delete"
				class="app-datablock-action-popup__delete">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.delete.multiple.description">
					deletion request
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.delete.description">
					deletion request
				</span>

				<div class="app-datablock-action-popup__delete-info">
					<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-datablock-action-popup__message"
						i18n="@@datablock.action.popup.delete.multiple.info">
						deletion info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-datablock-action-popup__message"
						i18n="@@datablock.action.popup.delete.info">
						deletion info
					</span>
				</div>
				<div class="app-datablock-action-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
							<span i18n="@@datablock.action.popup.delete.confirm">confirm delete</span>
					</mat-checkbox>
				</div>
			</div>
			<div
				*ngSwitchCase="DatablockAction.Persist"
				class="app-datablock-action-popup__persist">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.persist.multiple.description">
					Persist
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.persist.description">
					Persist
				</span>

				<div class="app-datablock-action-popup__persist-info">
					<mat-icon [svgIcon]="DcIcons.Info"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-datablock-action-popup__message"
						i18n="@@datablock.action.popup.persist.multiple.info">
						persistence info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-datablock-action-popup__message"
						i18n="@@datablock.action.popup.persist.info">
						persistence info
					</span>
				</div>
			</div>
			<div
				*ngSwitchCase="DatablockAction.Repersist"
				class="app-datablock-action-popup__repersist">
				<span
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.repersist.description">
					Persist
				</span>
			</div>
			<div
				*ngSwitchCase="DatablockAction.Depersist"
				class="app-datablock-action-popup__depersist">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.depersist.multiple.description">
					Persist
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-datablock-action-popup__description"
					i18n="@@datablock.action.popup.depersist.description">
					Persist
				</span>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-datablock-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="DatablockAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-datablock-action-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span i18n="@@datablock.action.popup.delete.btn">delete</span>
			</button>
			<button
				*ngSwitchCase="DatablockAction.Persist"
				id="{{ cmpId }}-persist-btn"
				class="app-datablock-action-popup__footer__btn"
				[color]="'primary'"
				(click)="confirmAction()"
				mat-raised-button>
				<span i18n="@@datablock.action.popup.persist.btn">delete</span>
			</button>
			<button
				*ngSwitchCase="DatablockAction.Repersist"
				id="{{ cmpId }}-repersist-btn"
				class="app-datablock-action-popup__footer__btn"
				[color]="'primary'"
				(click)="confirmAction()"
				mat-raised-button>
				<span i18n="@@datablock.action.popup.repersist.btn">repersist</span>
			</button>
			<button
				*ngSwitchCase="DatablockAction.Depersist"
				id="{{ cmpId }}-depersist-btn"
				class="app-datablock-action-popup__footer__btn"
				(click)="confirmAction()"
				mat-raised-button>
				<span i18n="@@datablock.action.popup.depersist.btn">depersist</span>
			</button>
		</ng-container>
	</div>
</app-modal>
